import React from "react";
import { useState } from "react";

// icons
import { FaCircleChevronRight } from "react-icons/fa6";
import BottleImage from "../../../assets/images/MedicationBottle.png";
import {
  FREQUENCY_MAPPING,
  DELIVERY_TYPE_MAPPING,
} from "./SubscriptionMappings";

const SubscriptionsIndexMobile = ({
  activeSubscriptions = [],
  inactiveSubscriptions = [],
  mailToLink,
}) => {
  const [activeTab, setActiveTab] = useState("active");

  const subscriptions =
    activeTab === "active" ? activeSubscriptions : inactiveSubscriptions;

  return (
    <div className="pb-4 space-y-4 md:hidden block">
      {/* Header */}

      {/* Toggle Buttons */}
      <div className="flex gap-4">
        <button
          className={`px-4 py-1 rounded-full text-sm font-medium ${
            activeTab === "active"
              ? "bg-[#FFDF5F] text-black"
              : "text-[#5144B4]"
          }`}
          onClick={() => setActiveTab("active")}
        >
          Active
        </button>
        <button
          className={`px-4 py-1 rounded-full text-sm font-medium ${
            activeTab === "expired"
              ? "bg-[#FFDF5F] text-black"
              : "text-[#5144B4]"
          }`}
          onClick={() => setActiveTab("expired")}
        >
          Inactive
        </button>
      </div>

      {/* Subscription Cards */}
      <div className="space-y-4">
        {subscriptions.map((subscription, index) => (
          <SubscriptionContentCardMobile
            key={index}
            subscription={subscription}
            mailToLink={mailToLink}
          />
        ))}
      </div>
    </div>
  );
};
const SubscriptionContentCardMobile = ({
  title = "Subscription Name",
  treatment = "HSV",
  price = "$XX.XX",
  frequency = "Suppressive",
  deliveryType = "Pickup",
  image,
  subscription,
  mailToLink,
}) => {
  return (
    <div className="border border-[#C4BCFF] rounded-lg p-4 flex flex-col gap-3">
      <div className="flex justify-between items-center">
        <div className="flex gap-4">
          <img
            src={BottleImage}
            alt={title}
            className="w-12 h-12 object-cover rounded-md"
          />
          <div className="flex flex-col text-sm">
            <span className="text-[#5144B4] font-semibold text-start">
              {title}
            </span>
            <span className="text-start">
              {`${subscription.treatment_name} ${subscription.name}`}
            </span>
            <span className="text-start">
              Price:{" "}
              <span className="text-[#5144B4]">$ {subscription.price}</span>
            </span>
          </div>
        </div>
        <a href={mailToLink} className="text-[#5144B4]">
          <FaCircleChevronRight />
        </a>
      </div>
      <div className="text-sm flex flex-col gap-1 items-start">
        <span>
          Frequency:{" "}
          <span className="text-[#5144B4]">
            {FREQUENCY_MAPPING[subscription.frequency]}
          </span>
        </span>
        <span>
          Delivery Type:{" "}
          <span className="text-[#5144B4]">
            {DELIVERY_TYPE_MAPPING[subscription.delivery_type]}
          </span>
        </span>
      </div>
    </div>
  );
};

export default SubscriptionsIndexMobile;
